<template>
  <div ref="dialogContainer" role="dialog" aria-label="registry" aria-modal="true" tabindex="-1" class="dialog-focus-hidden">
    <div class="padding-top-xl margin-bottom-m">
      <h4>{{ title }}</h4>
    </div>
    <section v-if="hasRegestries || showSignIn" class="nav-occasions padding-bottom-s">
      <div class="medium margin-bottom-xs">Manage your registry</div>
      <ul class="grid-y">
        <li v-if="showSignIn">
          <Link :href="defaultLinks.signinUrl" class="link-body" @click="setSignInRedirectParams"> Sign in </Link>
        </li>
        <li v-for="occasion of occasions" :key="occasion.registryId">
          <Link :href="`/registry/${occasion.registryId}`" class="link-body" @click.prevent="setDefaultRegistry(occasion.registryGUID)">
            {{ occasion.text }}
          </Link>
        </li>
      </ul>
    </section>

    <section v-for="(group, index) of linkGroups" :key="index" class="nav-registry-links padding-top-s">
      <div v-if="group.title" class="medium margin-bottom-xs">
        {{ group.title }}
      </div>
      <ul class="grid-y">
        <li v-for="link of group.items" :key="link.text">
          <Link :href="link.url" class="link-body">
            {{ link.text }}
          </Link>
        </li>
      </ul>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { useRegistry, useRegistryDropdown } from '~/composables/useRegistry';
import Link from '~/components/common/Link';

const dialogContainer = ref(null);
const envProps = useEnvProps();
const isMcom = envProps.isMcom;
const title = isMcom ? 'Gift Registry' : 'Registry';
const { hasRegestries, showSignIn, occasions, linkGroups } = useRegistryDropdown();
const { defaultLinks, setDefaultRegistry, setSignInRedirectParams } = useRegistry();

onMounted(() => {
  nextTick(() => {
    dialogContainer.value?.focus();
  });
});
</script>

<style lang="scss" scoped>
@import '~/assets/scss/mixins/index.scss';

.nav-occasions {
  border-bottom: $hr-gray-divider;
}

.nav-registry-links + .nav-registry-links {
  border-top: $hr-gray-divider;
  @include margin-top-s;
}

ul {
  gap: 16px;
  list-style: none;
}

.dialog-focus-hidden:focus {
  outline: none;
}
</style>
